<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <path
    class="cls-1"
    d="M 165.548 200.708 C 196.801 164.005 240.162 139.694 287.784 132.18 C 311.055 57.299 244.538 -14.691 168.053 2.595 C 91.567 19.881 62.477 113.483 115.688 171.075 C 129.088 185.577 146.407 195.87 165.548 200.708 Z M 116.281 333.316 C 116.298 301.13 123.915 269.399 138.506 240.713 L 60.722 240.713 C 30.036 240.713 5.158 265.587 5.158 296.276 L 5.158 314.796 C 5.158 381.469 62.572 449.995 161.472 462.958 C 131.918 426.245 115.952 380.449 116.281 333.316 Z M 328.159 166.629 C 199.845 166.629 119.645 305.534 183.805 416.657 C 247.961 527.781 408.355 527.781 472.51 416.657 C 487.139 391.318 494.842 362.574 494.842 333.316 C 494.435 241.428 420.046 167.037 328.159 166.629 Z M 378.162 351.836 L 328.159 351.836 C 319.358 352.255 311.889 345.449 311.49 336.647 L 311.49 248.489 C 311.49 235.374 325.687 227.178 337.047 233.734 C 342.32 236.78 345.568 242.403 345.568 248.489 L 345.568 316.647 L 379.643 316.647 C 389.053 316.647 396.682 324.276 396.682 333.686 C 396.489 343.014 388.971 350.528 379.643 350.725 L 378.162 351.836 Z"
  />
</template>
